import { AlpineComponent } from "alpinejs";
import {
  default as AjaxList,
  ListXDataContext as AjaxListXDataContext,
  ListOptions as AjaxListOptions
} from '../../../components/AjaxList/Classes/List';
import ListItem from "../../../components/AjaxList/Classes/Item";
import { IHistoryStateProps } from "../../../utils/historyState";

export type ListComponent = AlpineComponent<AjaxListXDataContext<ListItem> & {
  resetFilter: () => void;
}>;

export type ListOptions = AjaxListOptions & IHistoryStateProps;

const List = (options: ListOptions, filterData = {}):ListComponent => {
  return {
    ...AjaxList(options, filterData),

    resetFilter() {
      this.filter!.data = {};
    }
  }
}

export default List;
